/**
 * React Query mutation for translating texts to English
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation } from '@tanstack/react-query';

import api from '@/services/api';

import type { TranslateTextsPayload, TranslateTextsResponse } from '../types/campaign-texts.types';

export function useTranslateTexts() {
  return useMutation<TranslateTextsResponse, Error, TranslateTextsPayload>({
    mutationFn: (payload) =>
      api.post('/campaign-texts/translate', payload).then((r) => r.data.data),
  });
}
